import { Component, Input, OnInit } from '@angular/core';
import { AlertService, ContactsStoreService, IAlertType, PersonsStoreService } from '../../../../_shared/services';
import { Personen, SingleCompany } from '../../../../_shared/interfaces';

import { InvoicesStoreService } from "../../../../_shared/services";
import { Invoices, StatusButtons } from '../../../../_shared/interfaces';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from '@clr/angular';
import { RouterLink } from "@angular/router";
import {CurrencyPipe, DatePipe, NgIf} from "@angular/common";
import {
  ClarityIcons,
  checkCircleIcon,
  exclamationCircleIcon,
  exclamationTriangleIcon,
  infoCircleIcon
} from "@cds/core/icon";

@Component({
  selector: 'app-project-details-invoices',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    DatePipe,
    ClrIconModule,
    NgIf,
    CurrencyPipe
  ],
  templateUrl: './project-details-invoices.component.html',
  styleUrl: './project-details-invoices.component.sass'
})
export class ProjectDetailsInvoicesComponent implements OnInit {
  company: SingleCompany = {} as SingleCompany;
  person: Personen[] = [];

  invoices: Invoices[] = [];
  descSort= ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  statusText = '';


  @Input() cidstd: number = 0;
  @Input() pid: number = 0;
  @Input() pridstd: string = '';
  @Input() reqid: string = '';

  constructor(
      private css: ContactsStoreService,
      private pss: PersonsStoreService,
      private invss: InvoicesStoreService,
      private alertDispatcher: AlertService,
  ) {
    ClarityIcons.addIcons(infoCircleIcon, checkCircleIcon, exclamationCircleIcon, exclamationTriangleIcon)
  }

  ngOnInit(){
    this.css.getSingleCompany(this.cidstd)
        .subscribe(res => this.company = res.object[0]);
    this.pss.getSinglePersons(this.pid)
        .subscribe( res => this.person = res.object);

    this.loading = true;
    this.loadList();
  }

  statusButtons: StatusButtons[] = [
    { state: 'draft', display: 'Entwurf', label: 'alert-info', icon: 'info-circle'},
    { state: 'open', display: 'Offen', label: 'alert-info', icon: 'info-circle'},
    { state: 'partially', display: 'Teilbezahlt', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'overdue', display: 'Fällig', label: 'alert-danger', icon: 'exclamation-circle'},
    { state: 'paid', display: 'Bezahlt', label: 'alert-success', icon: 'check-circle'},
    { state: 'cancelled', display: 'Storniert', label: 'alert-warning', icon: 'exclamation-triangle'}
  ];

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(invoicestatus: string) {
    const statusline = this.findButtonStatus(invoicestatus, this.statusButtons);
    return statusline >= 0 ? this.statusButtons[statusline].label : 'alert-info';
  }

  loadList() {
    this.invss.getInvoices(0, 0, this.cidstd + '.' + this.pridstd, 0, 0,'all').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Rechnungen gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
          return;
        }
        this.invoices = data.object;
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      error: () => {
        return
      }
    })
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus) + " alert-sm";
  }
}
